/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompleteChallengeProfileResponse
 */
export interface CompleteChallengeProfileResponse {
    /**
     * Resolved canonical membership status after the write.
     * @type {string}
     * @memberof CompleteChallengeProfileResponse
     */
    status: CompleteChallengeProfileResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CompleteChallengeProfileResponse
     */
    declaredCountry?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompleteChallengeProfileResponse
     */
    declaredState?: string | null;
    /**
     * False when the membership now has both attestation and declared geo on file. Frontend uses this to dismiss the ProfileCompletionModal without waiting for a get-info refetch.
     * @type {boolean}
     * @memberof CompleteChallengeProfileResponse
     */
    needsCompletion: boolean;
}


/**
 * @export
 */
export const CompleteChallengeProfileResponseStatusEnum = {
    eligible: 'eligible',
    PrizeRestricted: 'prize-restricted',
    spectator: 'spectator',
    disabled: 'disabled'
} as const;
export type CompleteChallengeProfileResponseStatusEnum = typeof CompleteChallengeProfileResponseStatusEnum[keyof typeof CompleteChallengeProfileResponseStatusEnum];


/**
 * Check if a given object implements the CompleteChallengeProfileResponse interface.
 */
export function instanceOfCompleteChallengeProfileResponse(value: object): value is CompleteChallengeProfileResponse {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('needsCompletion' in value) || value['needsCompletion'] === undefined) return false;
    return true;
}

export function CompleteChallengeProfileResponseFromJSON(json: any): CompleteChallengeProfileResponse {
    return CompleteChallengeProfileResponseFromJSONTyped(json, false);
}

export function CompleteChallengeProfileResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompleteChallengeProfileResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'declaredCountry': json['declaredCountry'] == null ? undefined : json['declaredCountry'],
        'declaredState': json['declaredState'] == null ? undefined : json['declaredState'],
        'needsCompletion': json['needsCompletion'],
    };
}

export function CompleteChallengeProfileResponseToJSON(json: any): CompleteChallengeProfileResponse {
    return CompleteChallengeProfileResponseToJSONTyped(json, false);
}

export function CompleteChallengeProfileResponseToJSONTyped(value?: CompleteChallengeProfileResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'declaredCountry': value['declaredCountry'],
        'declaredState': value['declaredState'],
        'needsCompletion': value['needsCompletion'],
    };
}

